export const name = "WNRS x Bumble Date"
export const menu = "Bumble Date"
export const crossover = "Bumble"
export const suggestedPlayer = "2 players"
export const color = {
    primary: {
        main:  '#F8CB5E',
        contrastText: '#ffffff',
    },
    secondary: {
        main: '#201e1f',
    }
}
export const levels = ['Level 1 Perception', 'Level 2 Connection', 'Level 3 Reflection']
export const isExpansion = false

export const level1 = [
    "What was your first\n impression of me on\n Bumble vs. IRL?",
    "How would you describe\n what you think my type\n is in three words?",
    "What did you think\n about my first\n message?",
    "Between the two of us,\n Who seems like the better\n texter? Explain.",
]

export const level2 = [
    "What dating advice\n would you give your\n younger self?",
    "How old do you feel,\n emotionally?",
    "Will I find your ex on your\n Instagram feed? Why or\n why not?",
    "What's the most\n embarrassing thing\n that's ever happened\n to you on a date?",
    "Finish the sentence:\n Dating is __________.\n (Both Players)",
    "What did the people who\n raised you teach you\n about love?",
    "Describe your perfect date.",
    "What has being single\n taught you about yourself,\n if anything?",
    "What's your least favorite\n question to be asked on a\n date? What do you wish you\n were asked more?",
    "What are you\n passionate about?",
    "What are you not giving\n enough time to, currently?",
    "When's the last time\n you surprised yourself?",
    "What about my Bumble profile\n made you swipe right?",
    "Admit something:\n\n What could you have done\n better in your previous\n relationship(s)?",
    "Admit something:\n\n Is there an image of yourself\n you try to project on a first\n date that you wish you could\n let go of?",
    "Wild Card Write down a dating pet peeve.\n (30 seconds) Compare.",
    "Wild Card Write down the three most\n important things to\n you in a relationship.\n (30 seconds) Compare.",
    "Wild Card Create your own question."
]

export const level3 = [
    "What's the most attractive\n quality about me that\n isn't physical?",
    "How accurately did my\n Bumble profile reflect\n who I am IRL?",
    "Wild Card Based on what you've\n learned, rewrite each\n other's Bumble bios.\n (30 seconds) Compare.",
]